<template>
  <div class="inquiry-cta">
    <div class="inquiry-cta__text">
      <p class="inquiry-cta__label en-font">{{ label }}</p>
      <p class="inquiry-cta__title">{{ title }}</p>
      <p class="inquiry-cta__desc">
        <span v-for="(line, i) in desc" :key="i"><br v-if="i" />{{ line }}</span>
      </p>
    </div>
    <a :href="href" target="_blank" rel="noopener noreferrer" class="inquiry-btn">
      <span>{{ buttonText }}</span>
      <span class="inquiry-btn__arrow" aria-hidden="true"></span>
    </a>
  </div>
</template>

<script>
export default {
  name: "InquiryCta",
  props: {
    label: { type: String, default: "ONLINE INQUIRY" },
    title: { type: String, required: true },
    desc: { type: Array, default: () => [] },
    buttonText: { type: String, required: true },
    href: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/helpers/variables";

.inquiry-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 44px;
  padding: 6px 0 6px 32px;
  border-left: 3px solid $color-blue;
  .inquiry-cta__label {
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 3px;
    color: $color-blue;
    margin-bottom: 16px;
  }
  .inquiry-cta__title {
    font-size: 30px;
    font-weight: 700;
    line-height: 1.3;
    letter-spacing: -0.5px;
    color: $color-black;
    margin-bottom: 16px;
  }
  .inquiry-cta__desc {
    font-size: 16px;
    font-weight: 300;
    line-height: 1.75;
    color: #666;
  }
  .inquiry-btn {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 210px;
    height: 60px;
    padding: 0 36px;
    border: 1px solid $color-black;
    background-color: $color-white;
    font-size: 17px;
    font-weight: 400;
    color: $color-black;
    letter-spacing: -0.3px;
    transition: background-color 0.3s, border-color 0.3s, color 0.3s;
    .inquiry-btn__arrow {
      width: 8px;
      height: 8px;
      margin-left: 12px;
      border-top: 1px solid currentColor;
      border-right: 1px solid currentColor;
      transform: rotate(45deg);
      transition: transform 0.3s;
    }
    &:hover {
      background-color: $color-blue;
      border-color: $color-blue;
      color: $color-white;
      .inquiry-btn__arrow {
        transform: rotate(45deg) translate(2px, -2px);
      }
    }
  }
}
</style>
